var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-navbar",
        {
          attrs: { id: "header", type: "light", variant: "light", sticky: "" }
        },
        [
          _c("b-navbar-nav", [
            _c("h4", { staticClass: "mb-0" }, [_vm._v(_vm._s(_vm.title))])
          ]),
          _vm._v(" "),
          _c(
            "b-navbar-nav",
            { staticClass: "ml-auto" },
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c("export-sidebar", {
                        attrs: {
                          "sidebar-id": "sidebar-invoices-export",
                          "storage-key": "sidebar_invoices_export",
                          columns: _vm.exportableFields,
                          "data-to-export": _vm.dataToExport,
                          "data-mapper": _vm.mapInvoiceForExport,
                          "file-name": "Invoices.xlsx",
                          "sheet-name": "Invoices",
                          "is-busy": _vm.isBusy,
                          "items-count": _vm.totalRows
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { cols: "auto" } },
                    [
                      _c(
                        "b-button",
                        {
                          directives: [
                            {
                              name: "b-toggle",
                              rawName: "v-b-toggle.sidebar-fields",
                              modifiers: { "sidebar-fields": true }
                            }
                          ],
                          staticClass: "mr-2",
                          attrs: {
                            id: "table-settings",
                            size: "sm",
                            variant: "warning"
                          }
                        },
                        [_c("font-awesome-icon", { attrs: { icon: "cog" } })],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-tooltip",
                        {
                          attrs: {
                            target: "table-settings",
                            triggers: "hover",
                            variant: "warning",
                            noninteractive: ""
                          }
                        },
                        [_vm._v("\n            Колонки\n          ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          attrs: {
                            size: "sm",
                            variant: "success",
                            disabled: _vm.isBusy
                          },
                          on: {
                            click: function($event) {
                              return _vm.onCreate()
                            }
                          }
                        },
                        [
                          _vm.isBusy
                            ? _c("b-spinner", { attrs: { small: "" } })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("font-awesome-icon", {
                            staticClass: "mr-1",
                            attrs: { icon: "plus" }
                          }),
                          _vm._v("\n            Новый\n          ")
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "filters-drawer",
        {
          attrs: {
            query: _vm.filters.query,
            "is-busy": _vm.isBusy,
            "filter-tags": _vm.activeFilterTags
          },
          on: {
            "update:query": function($event) {
              return _vm.$set(_vm.filters, "query", $event)
            },
            "remove-tag": _vm.removeFilterTag,
            submit: _vm.onSearch,
            clear: _vm.onClearFilters
          }
        },
        [
          _c(
            "b-col",
            { attrs: { cols: "12" } },
            [
              _c("label", { staticClass: "small text-muted" }, [
                _vm._v("Период")
              ]),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "align-items-center" },
                [
                  _c(
                    "b-col",
                    [
                      _c("b-form-input", {
                        attrs: {
                          id: "input-start-date",
                          size: "sm",
                          type: "date"
                        },
                        model: {
                          value: _vm.filters.start_date,
                          callback: function($$v) {
                            _vm.$set(_vm.filters, "start_date", $$v)
                          },
                          expression: "filters.start_date"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "px-2", attrs: { cols: "auto" } },
                    [_c("span", [_vm._v("—")])]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    [
                      _c("b-form-input", {
                        attrs: {
                          id: "input-end-date",
                          size: "sm",
                          type: "date"
                        },
                        model: {
                          value: _vm.filters.end_date,
                          callback: function($$v) {
                            _vm.$set(_vm.filters, "end_date", $$v)
                          },
                          expression: "filters.end_date"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "mt-1", attrs: { cols: "12" } },
            [
              _c("label", { staticClass: "small text-muted" }, [
                _vm._v("Организация")
              ]),
              _vm._v(" "),
              _c("organization-select", {
                ref: "organization_select",
                attrs: {
                  id: "input-organization-select",
                  "initial-id": _vm.filters.org_id
                },
                on: { onSelect: _vm.onSelectOrganization }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "mt-1", attrs: { cols: "12" } },
            [
              _c("label", { staticClass: "small text-muted" }, [
                _vm._v("Заказчик")
              ]),
              _vm._v(" "),
              _c("customer-select", {
                ref: "customer_select",
                attrs: {
                  id: "input-customer-select",
                  "initial-id": _vm.filters.customer_id
                },
                on: { onSelect: _vm.onSelectCustomer }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "mt-1", attrs: { md: "6", cols: "12" } },
            [
              _c("label", { staticClass: "small text-muted" }, [
                _vm._v("Статус оплаты")
              ]),
              _vm._v(" "),
              _c(
                "b-form-select",
                {
                  attrs: { id: "input-statuses", size: "sm" },
                  model: {
                    value: _vm.filters.paid_type,
                    callback: function($$v) {
                      _vm.$set(_vm.filters, "paid_type", $$v)
                    },
                    expression: "filters.paid_type"
                  }
                },
                [
                  _c("option", { domProps: { value: -1 } }, [
                    _vm._v("Все статусы")
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.paidTypes, function(option) {
                    return _c("option", { domProps: { value: option.id } }, [
                      _vm._v(
                        "\n          " + _vm._s(option.name) + "\n        "
                      )
                    ])
                  })
                ],
                2
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("b-table", {
        ref: "invoices",
        staticClass: "mb-0 text-small",
        attrs: {
          id: "invoices",
          "sticky-header": "",
          "head-variant": "light",
          "tbody-tr-class": _vm.tbodyRowClass,
          "select-mode": "multi",
          striped: "",
          small: "",
          responsive: "",
          bordered: "",
          "show-empty": "",
          "empty-text": _vm.$t("message.common.emptyTable"),
          busy: _vm.isBusy,
          items: _vm.items,
          fields: _vm.renderedFields,
          "no-provider-filtering": "",
          "no-provider-paging": "",
          "no-provider-sorting": "",
          "no-local-sorting": ""
        },
        on: {
          "sort-changed": _vm.sortChanged,
          "row-clicked": _vm.onRowClicked,
          "row-dblclicked": _vm.onRowDblClicked
        },
        scopedSlots: _vm._u([
          {
            key: "table-busy",
            fn: function() {
              return [
                _c(
                  "div",
                  { staticClass: "text-center text-success my-2" },
                  [
                    _c("b-spinner", { staticClass: "align-middle" }),
                    _vm._v(" "),
                    _c("strong", [_vm._v("Загрузка")])
                  ],
                  1
                )
              ]
            },
            proxy: true
          },
          {
            key: "cell(show_details)",
            fn: function(row) {
              return [
                row.item.works.length > 0
                  ? _c(
                      "b-button",
                      {
                        attrs: { variant: "link", size: "sm" },
                        on: { click: row.toggleDetails }
                      },
                      [
                        row.detailsShowing
                          ? _c("font-awesome-icon", {
                              attrs: { icon: "chevron-up" }
                            })
                          : _c("font-awesome-icon", {
                              attrs: { icon: "chevron-down" }
                            })
                      ],
                      1
                    )
                  : _vm._e()
              ]
            }
          },
          {
            key: "row-details",
            fn: function(row) {
              return [
                _c("b-table", {
                  staticClass: "w-auto",
                  attrs: {
                    items: row.item.works,
                    fields: _vm.worksFields,
                    small: ""
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "cell(unit)",
                        fn: function(row) {
                          return [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.getUnitByCode(row.item.unit_code)
                                    .shortName
                                ) +
                                "\n        "
                            )
                          ]
                        }
                      },
                      {
                        key: "custom-foot",
                        fn: function(data) {
                          return [
                            _c(
                              "b-tr",
                              [
                                _c(
                                  "b-th",
                                  {
                                    staticClass: "text-right",
                                    attrs: { colspan: "5" }
                                  },
                                  [
                                    _vm._v("\n              Итого:"),
                                    _c("br"),
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.getTotalWorksSumText(row.item)
                                        ) +
                                        "\n            "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("b-th", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.priceFormat(
                                        _vm.getTotalWorksSum(row.item)
                                      )
                                    )
                                  )
                                ])
                              ],
                              1
                            )
                          ]
                        }
                      }
                    ],
                    null,
                    true
                  )
                })
              ]
            }
          },
          {
            key: "head(selected)",
            fn: function(row) {
              return [
                _c("b-form-checkbox", {
                  staticClass: "mx-1",
                  attrs: { indeterminate: _vm.indeterminate, size: "md" },
                  on: { change: _vm.selectPageRows },
                  model: {
                    value: _vm.allSelected,
                    callback: function($$v) {
                      _vm.allSelected = $$v
                    },
                    expression: "allSelected"
                  }
                })
              ]
            }
          },
          {
            key: "cell(selected)",
            fn: function(row) {
              return [
                row.item.selected
                  ? [
                      _c("span", { attrs: { "aria-hidden": "true" } }, [
                        _vm._v("✓")
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "sr-only" }, [
                        _vm._v("Выбрана")
                      ])
                    ]
                  : [
                      _c("span", [_vm._v(" ")]),
                      _vm._v(" "),
                      _c("span", { staticClass: "sr-only" }, [
                        _vm._v("Не выбрана")
                      ])
                    ]
              ]
            }
          },
          {
            key: "cell(customer_name)",
            fn: function(row) {
              return [
                _vm._v(
                  "\n      " + _vm._s(row.item.customer_name) + "\n      "
                ),
                _c("p", { staticClass: "m-0 p-0 text-secondary text-small" }, [
                  _vm._v(_vm._s(row.item.organization_name))
                ])
              ]
            }
          },
          {
            key: "cell(date)",
            fn: function(row) {
              return [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.formatTableDate(row.item.date)) +
                    "\n    "
                )
              ]
            }
          },
          {
            key: "cell(summa)",
            fn: function(row) {
              return [
                _c(
                  "div",
                  {
                    staticStyle: {
                      "text-align": "right",
                      "font-size": "medium"
                    }
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.priceFormat(row.item.summa)) +
                        "\n      "
                    )
                  ]
                )
              ]
            }
          },
          {
            key: "cell(paid_type)",
            fn: function(row) {
              return [
                _c(
                  "div",
                  { staticStyle: { "font-size": "medium" } },
                  [
                    _c(
                      "b-badge",
                      {
                        attrs: {
                          pill: "",
                          variant: _vm.getStatusStyle(row.item.paid_type)
                        },
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.showModalPayments(row.item)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.getStatusName(row.item.paid_type)) +
                            "\n          "
                        ),
                        _c("font-awesome-icon", {
                          staticClass: "ml-1",
                          attrs: { icon: "money-check-alt" }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            }
          },
          {
            key: "cell(acts)",
            fn: function(row) {
              return [
                _c(
                  "b-list-group",
                  { attrs: { flush: "" } },
                  _vm._l(row.item.acts, function(item, index) {
                    return _c(
                      "b-list-group-item",
                      {
                        key: index,
                        staticStyle: {
                          "background-color": "inherit",
                          padding: "0"
                        }
                      },
                      [
                        _c(
                          "b-button",
                          {
                            attrs: { size: "sm", variant: "link" },
                            on: {
                              click: function($event) {
                                return _vm.onActFile(item)
                              }
                            }
                          },
                          [_vm._v("Акт №" + _vm._s(item.numb))]
                        )
                      ],
                      1
                    )
                  }),
                  1
                )
              ]
            }
          },
          {
            key: "cell(action)",
            fn: function(row) {
              return [
                _c(
                  "b-dropdown",
                  {
                    attrs: { size: "sm", "no-caret": "" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "button-content",
                          fn: function() {
                            return [
                              _c("font-awesome-icon", {
                                attrs: { icon: "ellipsis-v" }
                              })
                            ]
                          },
                          proxy: true
                        }
                      ],
                      null,
                      true
                    )
                  },
                  [
                    _vm._v(" "),
                    _c(
                      "b-dropdown-item-button",
                      {
                        attrs: { variant: "success" },
                        on: {
                          click: function($event) {
                            return _vm.showModalPayments(row.item)
                          }
                        }
                      },
                      [
                        _c("font-awesome-icon", {
                          attrs: { icon: "file-invoice-dollar" }
                        }),
                        _vm._v("\n          Оплатить\n        ")
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-dropdown-item-button",
                      {
                        attrs: { variant: "info" },
                        on: {
                          click: function($event) {
                            return _vm.onInvoiceFile(row.item)
                          }
                        }
                      },
                      [
                        _c("font-awesome-icon", { attrs: { icon: "file" } }),
                        _vm._v("\n          Скачать\n        ")
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-dropdown-item-button",
                      {
                        attrs: { variant: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.onEdit(row)
                          }
                        }
                      },
                      [
                        _c("font-awesome-icon", { attrs: { icon: "edit" } }),
                        _vm._v("\n          Редактировать\n        ")
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-dropdown-item-button",
                      {
                        attrs: { variant: "danger" },
                        on: {
                          click: function($event) {
                            return _vm.onRemove(row)
                          }
                        }
                      },
                      [
                        _c("font-awesome-icon", { attrs: { icon: "trash" } }),
                        _vm._v("\n          Удалить\n        ")
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            }
          }
        ])
      }),
      _vm._v(" "),
      _c("pagination-footer", {
        attrs: { "total-rows": _vm.totalRows, "per-page": _vm.perPage },
        on: {
          "update:perPage": function($event) {
            _vm.perPage = $event
          },
          "update:per-page": function($event) {
            _vm.perPage = $event
          },
          "page-click": _vm.onPagination,
          "per-page-change": _vm.onPerPageChange
        },
        scopedSlots: _vm._u([
          {
            key: "footer-list",
            fn: function() {
              return [
                _c("div", { staticClass: "text-small" }, [
                  _vm._v("\n        Найдено "),
                  _c("b", [_vm._v(_vm._s(_vm.totalRows))]),
                  _vm._v(" счетов на сумму "),
                  _c("b", [_vm._v(_vm._s(_vm.total.total_sum))]),
                  _vm._v("\n        из них оплачено "),
                  _c("b", [_vm._v(_vm._s(_vm.total.paid_count))]),
                  _vm._v(" на сумму "),
                  _c("b", [_vm._v(_vm._s(_vm.total.paid_sum))]),
                  _vm._v(" руб.,\n        не оплачено "),
                  _c("b", [_vm._v(_vm._s(_vm.total.unpaid_count))]),
                  _vm._v(" на сумму "),
                  _c("b", [_vm._v(_vm._s(_vm.total.unpaid_sum))]),
                  _vm._v(" руб.,\n        частично оплачено "),
                  _c("b", [_vm._v(_vm._s(_vm.total.partial_count))]),
                  _vm._v(" на сумму "),
                  _c("b", [_vm._v(_vm._s(_vm.total.partial_sum))]),
                  _vm._v(" руб.\n      ")
                ])
              ]
            },
            proxy: true
          },
          {
            key: "footer-update",
            fn: function() {
              return [
                _vm.selected.length > 0
                  ? _c(
                      "b-row",
                      { attrs: { "align-h": "between", "align-v": "center" } },
                      [
                        _c(
                          "b-col",
                          {
                            staticClass: "mr-auto text-small",
                            attrs: { cols: "auto" }
                          },
                          [
                            _vm._v("\n          Выбрано: "),
                            _c("b", [_vm._v(_vm._s(_vm.selected.length))])
                          ]
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.selected.length > 0 ? _c("hr") : _vm._e()
              ]
            },
            proxy: true
          }
        ])
      }),
      _vm._v(" "),
      _c("invoices-payments", {
        ref: "invoicesPayments",
        on: { update: _vm.onUpdateInvoicePayments }
      }),
      _vm._v(" "),
      _c("DynamicTables", {
        attrs: {
          "storage-key": "invoices_columns",
          "sidebar-fields": "sidebar-fields",
          "fields-model": _vm.fields,
          fieldKey: "numb"
        },
        on: {
          "update:fieldsModel": function($event) {
            _vm.fields = $event
          },
          "update:fields-model": function($event) {
            _vm.fields = $event
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0807188f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0807188f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Invoices/Invoices.vue
// module id = null
// module chunks = 